import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Modal, Form, Spinner } from "react-bootstrap";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";

const getAuthToken = () => localStorage.getItem("authToken");

const Accounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ id: "", name: "", account_type_id: "", opening_balance: 0 });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchAccounts();
    fetchAccountTypes();
  }, []);

  const fetchAccounts = async () => {
    try {
      const response = await axios.get(`${appConstants.API_ROOT_URL}get-accounts`, {
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      setAccounts(response.data.data);
    } catch (error) {
      console.error("Failed to fetch accounts", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAccountTypes = async () => {
    try {
      const response = await axios.get(`${appConstants.API_ROOT_URL}get-account-types`, {
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      
      setAccountTypes(response.data.data);
    } catch (error) {
      console.error("Failed to fetch account types", error);
    }
  };

  const handleShowModal = (account = null) => {
    if (account) {
      setFormData({ name: account.name, account_type_id: account.account_type_id, description: account.description, opening_balance: account.opening_balance });
      setEditingId(account.id);
    } else {
      setFormData({ name: "", account_type_id: "" });
      setEditingId(null);
    }
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      const payload = { ...formData };
      let response;
  
      if (editingId) {
        
        response = await axios.post(
          `${appConstants.API_ROOT_URL}update-account`,
          {
            id:editingId,
            name: formData.name,
            account_type_id: formData.account_type_id,
            opening_balance: formData.opening_balance,
          },
          {
            headers: {
              Authorization: `Bearer ${getAuthToken()}`,
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        response = await axios.post(
          `${appConstants.API_ROOT_URL}create-account`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${getAuthToken()}`,
              "Content-Type": "application/json",
            },
          }
        );
      }
  
      fetchAccounts();
      setShowModal(false);
    } catch (error) {
      console.error("Failed to save account", error);
  
      // Show server error message if available
      if (error.response && error.response.data && error.response.data.message) {
        alert(`Error: ${error.response.data.message}`);
      } else {
        alert("An error occurred while saving the account.");
      }
    }
  };
  

  return (
    <Layout>
      <div className="container mt-4">
        <h3>Accounts Management</h3>
        <Button variant="primary" onClick={() => handleShowModal()}>
          <FaPlus /> Add Account
        </Button>
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <Table striped bordered hover className="mt-3">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Account Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {accounts.map((account, index) => (
                <tr key={account.id}>
                  <td>{index + 1}</td>
                  <td>{account.name}</td>
                  <td>{accountTypes.find((type) => type.id === account.account_type_id)?.name || "N/A"}</td>
                 
                  <td>
                    <Button variant="info" size="sm" onClick={() => handleShowModal(account)} className="me-2">
                      <FaEdit />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>{editingId ? "Edit Account" : "Add Account"}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>Name</Form.Label>
        <Form.Control
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Account Type</Form.Label>
        <Form.Select
          value={formData.account_type_id}
          onChange={(e) => setFormData({ ...formData, account_type_id: e.target.value })}
        >
          <option value="">Select Account Type</option>
          {accountTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* Opening Balance Field */}
      <Form.Group className="mb-3">
        <Form.Label>Opening Balance</Form.Label>
        <Form.Control
          type="number"
          value={formData?.opening_balance}
          onChange={(e) => setFormData({ ...formData, opening_balance: e.target.value })}
          placeholder="Enter opening balance"
        />
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>
      Close
    </Button>
    <Button variant="primary" onClick={handleSave}>
      Save Changes
    </Button>
  </Modal.Footer>
</Modal>

    </Layout>
  );
};

export default Accounts;
